<div class="moonflow-modal">
  <div class="header-dropdown-filter">
    <div class="title">{{ 'COMMON.FILTER_BY' | translate }}</div>
    <div class="close" (click)="close()">
      <button type="button" class="btn btn-icon-custom">
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
          <path d="M6.89545 5L9.73835 2.1571C10.0872 1.80824 10.0872 1.24261 9.73835 0.893466L9.10653 0.261648C8.75767 -0.0872159 8.19205 -0.0872159 7.8429 0.261648L5 3.10455L2.1571 0.261648C1.80824 -0.0872159 1.24261 -0.0872159 0.893466 0.261648L0.261648 0.893466C-0.0872159 1.24233 -0.0872159 1.80795 0.261648 2.1571L3.10455 5L0.261648 7.8429C-0.0872159 8.19176 -0.0872159 8.75739 0.261648 9.10653L0.893466 9.73835C1.24233 10.0872 1.80824 10.0872 2.1571 9.73835L5 6.89545L7.8429 9.73835C8.19176 10.0872 8.75767 10.0872 9.10653 9.73835L9.73835 9.10653C10.0872 8.75767 10.0872 8.19205 9.73835 7.8429L6.89545 5Z" fill="#5F6368"/>
        </svg>
      </button>
    </div>
  </div>
  <div class="body-content">
    <ng-container *ngFor="let item of filter;let i = index">
      <ng-container *ngIf="!item.hide">
        <div class="moonflow-row">
          <div class="moonflow-field">
            <div class="d-flex">
              <label>{{item.title | translate}}</label>
              <i class="fas fa-info-circle black ms-1" *ngIf="item.popover != null" [ngbPopover]="item.popover"
                triggers="mouseenter:mouseleave" style="vertical-align: middle;" placement="right" container="body"
                popoverClass="popover-title">
              </i>
            </div>

            <ng-container *ngIf="(!item.type  || item.type == DropdownFilterType.SELECT)">
              <ng-select class="select-filter" [dropdownPosition]="'bottom'"
                [closeOnSelect]="false" [appendTo]="appendTo ? '.'+appendTo : '.menu-sub-custom'"
                [(ngModel)]="item.selected" [placeholder]="'COMMON.SELECT' | translate" [multiple]="true" [searchable]="item.enabledSearchForSelected != null ? item.enabledSearchForSelected : true">
                <ng-template ng-label-tmp let-selectedItem="item" let-clear="clear">
                  <span class="d-inline-flex align-items-center">
                    <span class="ng-value-icon left" (click)="clear(selectedItem)" aria-hidden="true">×</span>
                    <span class="ng-value-label">{{selectedItem.label | translate}}</span>
                    <span *ngIf="item.showStatusDot" class="filter-status-dot filter-status-dot--{{selectedItem.status}}"></span>
                  </span>
                </ng-template>
                <ng-container *ngFor="let data of item.data">
                  <ng-option *ngIf="!data?.hide" [value]="data">
                    <div class="d-flex justify-content-between">
                      <div class="filter-value-label">
                        {{data.label | translate}}
                      </div>
                      <span *ngIf="item.showStatusDot" class="filter-status-dot filter-status-dot--{{data.status || data.value}}"></span>
                      <div class="icon-check">
                        <i class="fas fa-check"></i>
                      </div>
                    </div>
                  </ng-option>
                </ng-container>
              </ng-select>
            </ng-container>

            <ng-container *ngIf="item.type == DropdownFilterType.SELECT_SINGLE">
              <ng-select class="select-filter"
                (change)="onSelectSingleChange(item, $event)"
                [closeOnSelect]="false" [appendTo]="appendTo ? '.'+appendTo : '.menu-sub-custom'"
                [(ngModel)]="item.singleSelection" [placeholder]="'COMMON.SELECT' | translate" [multiple]="false">
                <ng-container *ngFor="let data of item.data">
                  <ng-option *ngIf="!data?.hide" [value]="data">
                    <span class="d-inline-flex align-items-center">
                      <span>{{data.label | translate}}</span>
                    </span>
                  </ng-option>
                </ng-container>
              </ng-select>
            </ng-container>

            <ng-container *ngIf="item.type == DropdownFilterType.INPUT_FROM_UNTIL_DATE">
              <div class="d-flex">
                <div class="w-50">
                  <input type="text" (click)="picker.open()" matInput
                    [max]="item.value2 || item.maxDate || (item.maxDaysBetween ? nowData : null)"
                    [min]="item.minDate || (minDateLimit != null ? this.minDateLimit : null)" [matDatepicker]="picker"
                    (dateChange)="changeDate(item)" [(ngModel)]="item.value" [placeholder]="'COMMON.FROM' | translate"
                    class="form-control form-control-sm filter-input filter-input-left">
                  <mat-datepicker #picker (closed)="emitDatePickerIsOpen(false)"
                    (opened)="emitDatePickerIsOpen(true)"></mat-datepicker>
                </div>
                <div class="w-50 ms-1">
                  <input type="text" (click)="picker2.open()" matInput [min]="item.value || item.minDate"
                    [max]="getMaxDate(item.value, item)" (dateChange)="changeDate(item)" [matDatepicker]="picker2"
                    [(ngModel)]="item.value2" [placeholder]="'COMMON.UNTIL' | translate"
                    class="form-control form-control-sm filter-input filter-input-right">
                  <mat-datepicker #picker2 (closed)="emitDatePickerIsOpen(false)"
                    (opened)="emitDatePickerIsOpen(true)"></mat-datepicker>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="item.type == DropdownFilterType.INPUT_FROM_UNTIL_NUMBER">
              <div class="d-flex">
                <div class="w-50">
                  <input type="text" appInputValidation [validationConfig]="'amountNegative'" [(ngModel)]="item.value"
                    [placeholder]="'COMMON.FROM' | translate"
                    class="form-control form-control-sm filter-input filter-input-left">
                </div>
                <div class="w-50 ms-1">
                  <input type="text" appInputValidation [validationConfig]="'amountNegative'" [(ngModel)]="item.value2"
                    [placeholder]="'COMMON.UNTIL' | translate"
                    class="form-control form-control-sm filter-input filter-input-right">
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="item.type == DropdownFilterType.INPUT">
              <div class="d-flex">
                <div class="w-100">
                  <input type="text" appInputValidation [validationConfig]="'amountNegative'" [(ngModel)]="item.value"
                    [placeholder]="'COMMON.FROM' | translate" class="form-control form-control-sm filter-input">
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="item.type == DropdownFilterType.INPUT_TEXT_AND_NUMBER">
              <div class="d-flex">
                <div class="w-100">
                  <input type="text" [(ngModel)]="item.value" [placeholder]="'COMMON.VALUE_PLACEHOLDER' | translate"
                    class="form-control form-control-sm filter-input">
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="item.type == DropdownFilterType.CHECKBOX_SWITCH">
              <div class="form-check form-switch form-check-custom form-check-solid">
                <input class="form-check-input  h-20px w-30px" type="checkbox" [(ngModel)]="item.value" #status />
                <label class="form-check-label" for="flexSwitch20x30">
                  <span *ngIf=" status.checked" [translate]="'COMMON.ACTIVE'"></span>
                  <span *ngIf="!status.checked" [translate]="'COMMON.INACTIVE'"></span>
                </label>
              </div>
            </ng-container>

            <ng-container *ngIf="item.type == DropdownFilterType.CHECKBOX_SWITCH_AI">
              <div class="form-check form-switch form-check-custom form-check-solid">
                <input class="form-check-input  h-20px w-30px" type="checkbox" [(ngModel)]="item.value" #status />
                <label class="form-check-label" for="flexSwitch20x30">
                  <span *ngIf="status.checked" [translate]="'COMMON.ACTIVE'"></span>
                  <span *ngIf="!status.checked" [translate]="'COMMON.INACTIVE'"></span>
                </label>
              </div>
            </ng-container>

          <app-entity-filter-select #clientSelect *ngIf="item.type == DropdownFilterType.SELECT_CLIENT_ID"
            [typeFilter]="DropdownFilterType.SELECT_CLIENT_ID" [appendTo]="appendTo" [documentTypes]="documentTypes"
            [(selectedData)]="item.selectedListFilter"
            [forceInitClient]="item.forceInitList" [minSearchLengthCustom]="item.minSearchLengthCustomList" [hierarchicalLevel]="item.hierarchicalLevel">
          </app-entity-filter-select>

          <app-entity-filter-select #creditSelect *ngIf="item.type == DropdownFilterType.SELECT_CREDIT_ID"
            [typeFilter]="DropdownFilterType.SELECT_CREDIT_ID" [appendTo]="appendTo" [isCreditModule]="isCreditModule"
            [(selectedData)]="item.selectedListFilter"
            [forceInitCredit]="item.forceInitList" [minSearchLengthCustom]="item.minSearchLengthCustomList">
          </app-entity-filter-select> 

          <app-entity-filter-select #paymentOrderSelect *ngIf="item.type == DropdownFilterType.SELECT_PAYMENT_ORDER_ID"
            [typeFilter]="DropdownFilterType.SELECT_PAYMENT_ORDER_ID" [appendTo]="appendTo" [(selectedData)]="item.selectedListFilter"
            [forceInitPaymentOrder]="item.forceInitList" [minSearchLengthCustom]="item.minSearchLengthCustomList">
          </app-entity-filter-select>

          <app-entity-filter-select #productPaymentOrderSelect *ngIf="item.type == DropdownFilterType.SELECT_PRODUCT_OP"
            [typeFilter]="DropdownFilterType.SELECT_PRODUCT_OP" [appendTo]="appendTo" [(selectedData)]="item.selectedListFilter"
            [forceInitProductPaymentOrder]="item.forceInitList" [minSearchLengthCustom]="item.minSearchLengthCustomList">
          </app-entity-filter-select>   

          <app-entity-filter-select #tradeNameSelect *ngIf="item.type == DropdownFilterType.SELECT_TRADE_NAME_CLIENT"
            [typeFilter]="DropdownFilterType.SELECT_TRADE_NAME_CLIENT" [appendTo]="appendTo" [(selectedData)]="item.selectedListFilter"
            [forceInitTradeNames]="item.forceInitList" [minSearchLengthCustom]="item.minSearchLengthCustomList">
          </app-entity-filter-select>

          <app-entity-filter-select #extraFieldsSelect *ngIf="item.type == DropdownFilterType.SELECT_EXTRA_FIELDS"
            [typeFilter]="DropdownFilterType.SELECT_EXTRA_FIELDS" [appendTo]="appendTo" [(selectedData)]="item.selectedListFilter"
            [forceInitProductPaymentOrder]="item.forceInitList" [fieldName]="item.fieldName" [minSearchLengthCustom]="item.minSearchLengthCustomList">
          </app-entity-filter-select>

          <app-entity-filter-select #productCreditSelect *ngIf="item.type == DropdownFilterType.SELECT_PRODUCT_CREDIT"
          [typeFilter]="DropdownFilterType.SELECT_PRODUCT_CREDIT" [appendTo]="appendTo" [(selectedData)]="item.selectedListFilter"
          [forceInitProductCredit]="item.forceInitList" [typesProductCredit]="item.typesProductCredit"
          [onlyByUserProductCredit]="item.onlyByUserProductCredit" [minSearchLengthCustom]="item.minSearchLengthCustomList">
          </app-entity-filter-select>

          <app-entity-filter-select #sourcesCreditSelect *ngIf="item.type == DropdownFilterType.SELECT_SOURCES_CREDIT"
          [typeFilter]="DropdownFilterType.SELECT_SOURCES_CREDIT" [appendTo]="appendTo"
          [(selectedData)]="item.selectedListFilter"
          [forceInitSourcesCredit]="item.forceInitList" [minSearchLengthCustom]="item.minSearchLengthCustomList">
          </app-entity-filter-select>    

          <app-entity-filter-select #campaignFilterSelect *ngIf="item.type == DropdownFilterType.SELECT_CAMPAIGN_FILTER"
          [typeFilter]="DropdownFilterType.SELECT_CAMPAIGN_FILTER" [appendTo]="appendTo"
          [(selectedData)]="item.selectedListFilter"
          [statusCampaignList]="item.statusCampaignList"
          [forceInitCampaign]="item.forceInitList" [minSearchLengthCustom]="item.minSearchLengthCustomList">
          </app-entity-filter-select>  

          <app-entity-filter-select #productPurchaseOrderSelect *ngIf="item.type == DropdownFilterType.SELECT_PRODUCT_PURCHASE_ORDER"
          [typeFilter]="DropdownFilterType.SELECT_PRODUCT_PURCHASE_ORDER" [appendTo]="appendTo" [(selectedData)]="item.selectedListFilter"
          [forceInitProductPurchaseOrder]="item.forceInitList" [minSearchLengthCustom]="item.minSearchLengthCustomList">
          </app-entity-filter-select>

          <app-entity-filter-select #periodPurchaseOrderSelect *ngIf="item.type == DropdownFilterType.SELECT_PERIOD_PURCHASE_ORDER"
            [typeFilter]="DropdownFilterType.SELECT_PERIOD_PURCHASE_ORDER" [appendTo]="appendTo" [(selectedData)]="item.selectedListFilter"
            [forceInitPeriodPurchaseOrder]="item.forceInitList" [minSearchLengthCustom]="item.minSearchLengthCustomList">
          </app-entity-filter-select> 
          
          <app-entity-filter-select #saleExternalIdPurchaseOrderSelect *ngIf="item.type == DropdownFilterType.SELECT_SALE_EXTERNAL_ID_PURCHASE_ORDER"
            [typeFilter]="DropdownFilterType.SELECT_SALE_EXTERNAL_ID_PURCHASE_ORDER" [appendTo]="appendTo" [(selectedData)]="item.selectedListFilter"
            [forceInitSaleExternalIdPurchaseOrder]="item.forceInitList" [minSearchLengthCustom]="item.minSearchLengthCustomList">
          </app-entity-filter-select>
          
          <app-entity-filter-select #collectionReconciliationSelect *ngIf="item.type == DropdownFilterType.SELECT_COLLECTION_BANK_NAME"
            [typeFilter]="DropdownFilterType.SELECT_COLLECTION_BANK_NAME" [appendTo]="appendTo" [(selectedData)]="item.selectedListFilter"
            [forceInitCollectionReconciliation]="item.forceInitList" [minSearchLengthCustom]="item.minSearchLengthCustomList">
          </app-entity-filter-select>
          
          <app-entity-filter-select #projectCustomVariableSelect *ngIf="item.type == DropdownFilterType.SELECT_PROJECT_CUSTOM_VARIABLE" [customVariableType]="this.customVariableType"
            [projectCustomVariableId]="item.id"
            [typeFilter]="DropdownFilterType.SELECT_PROJECT_CUSTOM_VARIABLE" [appendTo]="appendTo" [(selectedData)]="item.selectedListFilter"
            [forceInitProjectCustomVariable]="item.forceInitList" [minSearchLengthCustom]="item.minSearchLengthCustomList">
          </app-entity-filter-select>

          </div>
        </div>
      </ng-container>
    </ng-container>

  </div>

  <div class="footer-content">
    <div>
      <button class="btn btn-icon btn-action" (click)="cleanFilter()" data-kt-menu-dismiss="true"
        [ngbPopover]="'COMMON.CLEAN' | translate" placement="bottom" container="body" triggers="mouseenter:mouseleave">
        <span class="svg-icon-2 svg-filter-icon" [inlineSVG]="'./assets/media/svg/warmi/broom.svg'"></span>
      </button>

      <button class="btn btn-icon btn-action me-2" *ngIf="showButtonReset" (click)="resetFilter()"
        data-kt-menu-dismiss="true" [ngbPopover]="'COMMON.RESET' | translate" placement="bottom" container="body"
        triggers="mouseenter:mouseleave">
        <i class="fas fa-undo"></i>
      </button>
    </div>

    <div class="d-flex">
      <button class="btn btn-footer-cancel" *ngIf="showButtonSave" (click)="saveFilters()" data-kt-menu-dismiss="true">
        {{ 'COMMON.SAVE' | translate }}
      </button>

      <button class="btn btn-footer-success ms-2" (click)="sendFilters()" data-kt-menu-dismiss="true">
        {{ 'COMMON.APPLY' | translate }}
      </button>
    </div>
  </div>
</div>
